/* ============================================================
   BACKWARDS NYC — THEME JS
   ============================================================ */

(function() {
  'use strict';

  // ── ANNOUNCEMENT BAR HEIGHT ──
  function setAnnouncementOffset() {
    const bar = document.getElementById('announcementBar');
    if (bar && bar.style.display !== 'none') {
      document.body.classList.add('has-announcement');
    }
  }
  setAnnouncementOffset();

  // ── CUSTOM CURSOR ──
  const cursor  = document.getElementById('cursor');
  const cursorR = document.getElementById('cursorRing');
  if (cursor && cursorR && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    let mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      cursor.style.transform = `translate(${mx-3}px,${my-3}px)`;
    });
    const loop = () => {
      rx += (mx - rx - 15) * 0.1;
      ry += (my - ry - 15) * 0.1;
      cursorR.style.transform = `translate(${rx}px,${ry}px)`;
      requestAnimationFrame(loop);
    };
    loop();
    document.querySelectorAll('a,button,.prod-card,.size-btn,.gallery-thumb').forEach(el => {
      el.addEventListener('mouseenter', () => { cursorR.style.width='48px'; cursorR.style.height='48px'; cursorR.style.borderColor='rgba(200,184,154,.65)'; });
      el.addEventListener('mouseleave', () => { cursorR.style.width='30px'; cursorR.style.height='30px'; cursorR.style.borderColor='rgba(200,184,154,.4)'; });
    });
  }

  // ── NAV SCROLL BEHAVIOR ──
  const nav = document.querySelector('.nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.style.background = window.scrollY > 60 ? 'rgba(8,8,7,.97)' : 'rgba(8,8,7,.92)';
    }, { passive: true });
  }

  // ── MOBILE MENU ──
  const hamburger    = document.getElementById('hamburger');
  const mobileMenu   = document.getElementById('mobileMenu');
  const mobileOverlay = document.getElementById('mobileOverlay');
  function closeMobileMenu() {
    hamburger && hamburger.classList.remove('open');
    hamburger && hamburger.setAttribute('aria-expanded','false');
    mobileMenu && mobileMenu.classList.remove('open');
    mobileOverlay && mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const open = hamburger.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', open);
      mobileMenu.classList.toggle('open', open);
      mobileOverlay && mobileOverlay.classList.toggle('open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileOverlay && mobileOverlay.addEventListener('click', closeMobileMenu);
    mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMobileMenu));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMobileMenu(); });
  }

  // ── SCROLL REVEAL ──
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => entry.target.classList.add('visible'), (i % 4) * 80);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
    document.querySelectorAll('.reveal').forEach(el => obs.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('visible'));
  }

  // ── SMOOTH ANCHOR SCROLL ──
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const navH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-h')) || 68;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - navH - 16, behavior: 'smooth' });
      }
    });
  });

  // ── ACCORDION (product page + FAQ) ──
  document.querySelectorAll('.accordion-btn, .faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.accordion-item, .faq-item');
      const isOpen = item.classList.contains('open');
      // Close siblings
      const parent = item.parentElement;
      parent.querySelectorAll('.accordion-item.open, .faq-item.open').forEach(el => el.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── PRODUCT GALLERY THUMBNAILS ──
  const galleryMain   = document.getElementById('galleryMain');
  const galleryThumbs = document.querySelectorAll('.gallery-thumb');
  if (galleryMain && galleryThumbs.length) {
    galleryThumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        const img = galleryMain.querySelector('img');
        if (img && src) {
          img.src = src;
          img.alt = thumb.dataset.alt || '';
        }
        galleryThumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  // ── SIZE SELECTION ──
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('unavailable')) return;
      const group = btn.closest('.size-grid');
      group.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      // Update hidden variant input for Shopify form
      const variantInput = document.getElementById('variantId');
      if (variantInput && btn.dataset.variantId) {
        variantInput.value = btn.dataset.variantId;
      }
      // Update stock message
      const stockEl = document.getElementById('stockMessage');
      if (stockEl && btn.dataset.stock) {
        const stock = parseInt(btn.dataset.stock);
        if (stock <= 0) {
          stockEl.textContent = 'Sold Out';
          stockEl.className = 'pdp-stock';
          document.querySelector('.btn-add') && (document.querySelector('.btn-add').disabled = true);
        } else if (stock <= 5) {
          stockEl.textContent = `Only ${stock} left`;
          stockEl.className = 'pdp-stock low';
          document.querySelector('.btn-add') && (document.querySelector('.btn-add').disabled = false);
        } else {
          stockEl.textContent = 'In Stock';
          stockEl.className = 'pdp-stock good';
          document.querySelector('.btn-add') && (document.querySelector('.btn-add').disabled = false);
        }
      }
    });
  });

  // ── CART QUANTITY BUTTONS ──
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-wrap').querySelector('.qty-input');
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'increase') val = Math.min(val + 1, 99);
      if (btn.dataset.action === 'decrease') val = Math.max(val - 1, 1);
      input.value = val;
    });
  });

  // ── SHIPPING BAR ──
  const shippingBar = document.getElementById('shippingBar');
  if (shippingBar) {
    const threshold = 7500; // $75 in cents
    const cartTotal = parseInt(shippingBar.dataset.cartTotal) || 0;
    const fill = shippingBar.querySelector('.shipping-bar-fill');
    const text = shippingBar.querySelector('.shipping-bar-text');
    const pct = Math.min((cartTotal / threshold) * 100, 100);
    if (fill) fill.style.width = pct + '%';
    if (text) {
      if (cartTotal >= threshold) {
        text.innerHTML = '<strong>You\'ve unlocked free shipping!</strong> 🎉';
      } else {
        const remaining = ((threshold - cartTotal) / 100).toFixed(2);
        text.innerHTML = `You're <strong>$${remaining} away</strong> from free shipping`;
      }
    }
  }

  // ── NEWSLETTER FORM ──
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', e => {
      const btn = newsletterForm.querySelector('.newsletter-btn');
      if (btn) {
        setTimeout(() => {
          btn.textContent = 'You\'re in ✓';
          btn.style.background = 'var(--accent)';
        }, 400);
      }
    });
  }

  // ── CONTACT FORM FEEDBACK ──
  const contactForm = document.getElementById('contactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', () => {
      const btn = contactForm.querySelector('.form-submit .btn');
      if (btn) btn.textContent = 'Message Sent ✓';
    });
  }

})();
